import { Popover, PopoverContent, PopoverTrigger } from '@talentmesh/ui/components/popover';
import { useState } from 'react';
import BaseFilterButton, { BaseFilterButtonProps } from './BaseFilterButton';

export interface BaseFilterProps extends Pick<BaseFilterButtonProps, 'label' | 'activeFilterCount'> {
    children: React.ReactNode;
}

function BaseFilter({ label, activeFilterCount, children }: BaseFilterProps) {
    const [open, setOpen] = useState<boolean>(false);

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <BaseFilterButton open={open} label={label} activeFilterCount={activeFilterCount} />
            </PopoverTrigger>
            <PopoverContent
                data-cy="AdvancedFilterPanel"
                side="bottom"
                align="start"
                className="flex w-full min-w-80 gap-0 p-0"
            >
                {children}
            </PopoverContent>
        </Popover>
    );
}

export default BaseFilter;
